module.exports = __webpack_public_path__ + "static/media/folder.b236ec34.svg";